/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */
import React from 'react';

var ProgressBar = function ProgressBar(_ref) {
  var percent = _ref.percent;
  return React.createElement("div", {
    className: "form-group"
  }, React.createElement("div", {
    className: "col-sm-12"
  }, React.createElement("div", {
    className: "progress"
  }, React.createElement("div", {
    className: "progress-bar progress-bar-success",
    style: {
      width: "".concat(percent, "%")
    }
  }, React.createElement("span", {
    className: "percentage"
  }, "".concat(percent || 0, "%"))))));
};

export default ProgressBar;